module.exports = __webpack_public_path__ + "media/images/logo-white-baea88b2c843b5430e13d72be9e2a4da.svg";